module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("GENERAL TOPOGRAPHIC SETTING")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "row well"
  }, _vm._l((_vm.topographicSettingSelectedList), function(setting) {
    return _c('div', {
      staticClass: "col-md-3 checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (setting.topographicSettingId),
        expression: "setting.topographicSettingId"
      }],
      attrs: {
        "readonly": "",
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(setting.topographicSettingId) ? _vm._i(setting.topographicSettingId, null) > -1 : (setting.topographicSettingId)
      },
      on: {
        "change": function($event) {
          var $$a = setting.topographicSettingId,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (setting.topographicSettingId = $$a.concat([$$v]))
            } else {
              $$i > -1 && (setting.topographicSettingId = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(setting, "topographicSettingId", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', [_vm._v(_vm._s(setting.description))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Geographic Division")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "row well"
  }, _vm._l((_vm.geographicDivisionSelectedList), function(division) {
    return _c('div', {
      staticClass: "col-md-3 checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (division.geographicDivisionId),
        expression: "division.geographicDivisionId"
      }],
      attrs: {
        "readonly": "",
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(division.geographicDivisionId) ? _vm._i(division.geographicDivisionId, null) > -1 : (division.geographicDivisionId)
      },
      on: {
        "change": function($event) {
          var $$a = division.geographicDivisionId,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (division.geographicDivisionId = $$a.concat([$$v]))
            } else {
              $$i > -1 && (division.geographicDivisionId = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(division, "geographicDivisionId", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', [_vm._v(_vm._s(division.description))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("UNIQUE SITE SETTING")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "row well"
  }, _vm._l((_vm.uniqueSettingSelectedList), function(setting) {
    return _c('div', {
      staticClass: "col-md-3 checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (setting.uniqueSettingId),
        expression: "setting.uniqueSettingId"
      }],
      attrs: {
        "readonly": "",
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(setting.uniqueSettingId) ? _vm._i(setting.uniqueSettingId, null) > -1 : (setting.uniqueSettingId)
      },
      on: {
        "change": function($event) {
          var $$a = setting.uniqueSettingId,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (setting.uniqueSettingId = $$a.concat([$$v]))
            } else {
              $$i > -1 && (setting.uniqueSettingId = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(setting, "uniqueSettingId", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', [_vm._v(_vm._s(setting.description))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("BARE GROUND PERCENTAGE")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-control"
  }, [_vm._v(_vm._s(_vm.siteSetting.percentBareGround))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("GENERAL TOPOGRAPHIC SETTING")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control"
  }, [_vm._v(_vm._s(_vm.siteSetting.generalTopographicSetting))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("VEGETATION ASSOCIATION")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "row well"
  }, _vm._l((_vm.vegetationTypeSelectedList), function(type) {
    return _c('div', {
      staticClass: "col-md-3 checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (type.vegetationTypeId),
        expression: "type.vegetationTypeId"
      }],
      attrs: {
        "readonly": "",
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(type.vegetationTypeId) ? _vm._i(type.vegetationTypeId, null) > -1 : (type.vegetationTypeId)
      },
      on: {
        "change": function($event) {
          var $$a = type.vegetationTypeId,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (type.vegetationTypeId = $$a.concat([$$v]))
            } else {
              $$i > -1 && (type.vegetationTypeId = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(type, "vegetationTypeId", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', [_vm._v(_vm._s(type.description))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("GENERAL DEPOSITIONAL ENVIRONMENT")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "row well"
  }, _vm._l((_vm.depositionalTypeSelectedList), function(type) {
    return _c('div', {
      staticClass: "col-md-3 checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (type.depositionalTypeId),
        expression: "type.depositionalTypeId"
      }],
      attrs: {
        "readonly": "",
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(type.depositionalTypeId) ? _vm._i(type.depositionalTypeId, null) > -1 : (type.depositionalTypeId)
      },
      on: {
        "change": function($event) {
          var $$a = type.depositionalTypeId,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (type.depositionalTypeId = $$a.concat([$$v]))
            } else {
              $$i > -1 && (type.depositionalTypeId = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(type, "depositionalTypeId", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', [_vm._v(_vm._s(type.description))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("AEOLIAN SETTINGS")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-control"
  }, [_vm._v(_vm._s(_vm.aeolianTypeLabel))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.siteSetting.aeolianSettingsId == 1),
      expression: "siteSetting.aeolianSettingsId == 1"
    }],
    staticClass: "col-md-7"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row well"
  }, _vm._l((_vm.aeolianTypeSelectedList), function(type) {
    return _c('div', {
      staticClass: "col-md-3 checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (type.aeolianTypeId),
        expression: "type.aeolianTypeId"
      }],
      attrs: {
        "readonly": "",
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(type.aeolianTypeId) ? _vm._i(type.aeolianTypeId, null) > -1 : (type.aeolianTypeId)
      },
      on: {
        "change": function($event) {
          var $$a = type.aeolianTypeId,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (type.aeolianTypeId = $$a.concat([$$v]))
            } else {
              $$i > -1 && (type.aeolianTypeId = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(type, "aeolianTypeId", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', [_vm._v(_vm._s(type.description))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("SUBSURFACE POTENTIAL")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-control"
  }, [_vm._v(_vm._s(_vm.subsurfacePotentialLabel))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.siteSetting.subsurfacePotentialId == 1),
      expression: "siteSetting.subsurfacePotentialId == 1"
    }],
    staticClass: "col-md-7"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row well"
  }, _vm._l((_vm.depositEstimateBasisSelectedList), function(deposit) {
    return _c('div', {
      staticClass: "col-md-3 checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deposit.depositEstimateBasisId),
        expression: "deposit.depositEstimateBasisId"
      }],
      attrs: {
        "readonly": "",
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(deposit.depositEstimateBasisId) ? _vm._i(deposit.depositEstimateBasisId, null) > -1 : (deposit.depositEstimateBasisId)
      },
      on: {
        "change": function($event) {
          var $$a = deposit.depositEstimateBasisId,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (deposit.depositEstimateBasisId = $$a.concat([$$v]))
            } else {
              $$i > -1 && (deposit.depositEstimateBasisId = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(deposit, "depositEstimateBasisId", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', [_vm._v(_vm._s(deposit.description))])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Late Pleistocene and Holocene aeolian deposits")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Type(s) of aeolian setting(s)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Archaeological subsurface deposits")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Estimate based on")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7798ada1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteProduction/SiteSetting.vue
// module id = 963
// module chunks = 1